import { css } from '@emotion/react'
import styled from '@emotion/styled'

const iconStyles = ({ theme }) => css`
  width: 30px;
  height: 30px;
  margin-right: 7px;

  ${theme.media.mega} {
    margin-right: 12px;
  }
`

const messageStyles = ({ theme }) => css`
  font-size: 17px;
  font-weight: 400;
  margin-bottom: 6px;
  flex: 1;

  ${theme.media.mega} {
    flex: unset;
    margin-bottom: 0;
  }
`

const buyWithWhatsAppStyles = ({ theme }) => css`
  color: ${theme.colors.p200};
`

const driveThruStyles = css`
  text-decoration: underline;
`

const phoneStyles = ({ theme }) => css`
  color: ${theme.colors.white};
  font-weight: ${theme.font.weight.semibold}
  font-size: 17px;
  white-space: nowrap;
  position: relative;
  padding-left: 12px;
  margin-left: 12px;

  &:before {
    content: '';
    position: absolute;
    width: 2px;
    background: white;
    height: 10px;
    top: 10px;
    left: 0;
    opacity: .5;
  }
`

const disclaimerStyles = ({ theme }) => css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  ${theme.media.mega} {
    justify-content: center;
  }
`

const disclaimerDriveThruStyles = ({ theme, isDriveThru }) =>
  isDriveThru &&
  css`
    ${Icon} {
      order: 2;
      margin-top: 7px;

      ${theme.media.mega} {
        order: 1;
      }
    }

    ${Message} {
      order: 1;
      flex-basis: 100%;

      ${theme.media.mega} {
        order: 2;
        flex-basis: auto;
      }
    }

    ${Phone} {
      font-size: 22px;
      order: 3;
      padding-left: 0;
      margin-left: 0;

      ${theme.media.mega} {
        font-size: 17px;
        padding-left: 12px;
        margin-left: 12px;
      }

      &:before {
        display: none;

        ${theme.media.mega} {
          display: block;
        }
      }
    }
  `

export const Disclaimer = styled('div')(
  disclaimerStyles,
  disclaimerDriveThruStyles
)
export const Message = styled('p')(messageStyles)
export const BuyWithWhatsApp = styled('span')(buyWithWhatsAppStyles)
export const DriveThru = styled('span')(driveThruStyles)
export const Phone = styled('span')(phoneStyles)
export const Icon = styled('svg')(iconStyles)
